import { render, staticRenderFns } from "./module-fallback.vue?vue&type=template&id=314eb326"
import script from "./module-fallback.vue?vue&type=script&lang=js"
export * from "./module-fallback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports